import { DEFAULT_PHONE_NUMBER } from 'constants/phoneNumbers';
export default phoneNr => {
  return phoneNr.substring(0, 3) === DEFAULT_PHONE_NUMBER;
};